import { connections } from "./endpoints";

export const environment = {
  production: false,
  hmr: false,
  ...connections.staging
};
